var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_464_291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.79692 16.1285C12.8458 16.1285 16.128 12.8462 16.128 8.79735C16.128 4.74849 12.8458 1.46625 8.79692 1.46625C4.74807 1.46625 1.46582 4.74849 1.46582 8.79735C1.46582 12.8462 4.74807 16.1285 8.79692 16.1285Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79768 1.46625C6.91522 3.44283 5.86523 6.06779 5.86523 8.79735C5.86523 11.5269 6.91522 14.1519 8.79768 16.1285C10.6801 14.1519 11.7301 11.5269 11.7301 8.79735C11.7301 6.06779 10.6801 3.44283 8.79768 1.46625Z",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.46582 8.7973H16.128",
    strokeWidth: 1.46622,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_464_291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.5947,
    height: 17.5947,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeb);
export default __webpack_public_path__ + "static/media/web.35eedbbb62fc6772e1b8314d23cd1519.svg";
export { ForwardRef as ReactComponent };